import { apiHelper } from '@/util'
import { SHARED } from '@/constants/constants'

export const bonusService = {
  getMinimumBonusDeposit,
  getCategory,
  getAnonBonusList,
  getManualBonusList,
  getMemberAvailableBonusList,
  getBonusHistory,

  getOverallBonusStatus,
  getBonusStatus,
  claimBonus,
  applyBonus,

  checkVoucherBonus,
  applyVoucherBonus,

  checkVipBonus,
  applyVipBonus,
  getRewardCoins,
  getCoinsLogs,
  grabCoinNow,

  claimProgressReward,

  getVipSummary,
  getRebateHistory,
  claimRebate,
  getIPLVipSummary,
  claimIPLProgressReward,
  getIPLEventStatus,
  getRebateSummaryHistory,
  getRebateSummaryDetail
}

//API URLs
const BONUS = {
  BONUS: 'bonus',
  MINIMUMDEPOSIT: '/percentage/minimumDeposit',
  CATEGORY: 'category',
  OVERALLSTATUS: 'overallstatus',
  HISTORY: 'history',
  STATUS: 'status',
  CLAIM: 'claim',
  VOUCHER: 'voucher',
  APPLY: 'apply',
  CHECK: 'check',
  MEMBER: 'member',
  VIPBONUS: 'vipBonus',
  VIPPROGRESS: 'vipProgress',
  IPLVIPPROGRESS: 'vipEventProgress',
  GRAB_COIN_SETTINGS: '/reward/grab-coin',
  COIN_LOGS: '/reward/coin-logs',
  GRAB_COIN: '/reward/grab',
  VIP_REWARDS_SUMMARY: 'vipRewardsSummary',
  IPL_VIP_REWARDS_SUMMARY: 'vipEventRewardsSummary',
  REBATE_HISTORY: 'rebate/all',
  REWARD_WALLET: 'rewardWallet/log',
  IPLEVENTDATE: 'ipl/eventDate',
  REBATE_SUMMARY_HISTORY: 'rebate_and_bonus/summary/history',
  REBATE_SUMMARY_DETAIL: 'rebate/summary/detail'
}

function grabCoinNow() {
  return apiHelper().post(`${BONUS.GRAB_COIN}`)
}

function getCoinsLogs(filter) {
  const requestOptions = {
    params: {
      currency: filter.currency
    }
  }
  return apiHelper().get(`${BONUS.COIN_LOGS}`, requestOptions)
}

function getRewardCoins(filter) {
  const requestOptions = {
    params: {
      currency: filter.currency
    }
  }
  return apiHelper().get(`${BONUS.GRAB_COIN_SETTINGS}`, requestOptions)
}

function getBonusHistory(data) {
  const requestOptions = {
    params: {
      overall_status: data.overallStatus,
      apply_start_time: data.fromDate,
      apply_end_time: data.toDate,
      page: data.page,
      size: data.itemsPerPage
    }
  }
  return apiHelper().get(`/${BONUS.BONUS}/${BONUS.HISTORY}`, requestOptions)
}

function getAnonBonusList() {
  const requestBody = {
    params: {
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper(null, false).get(`/${BONUS.BONUS}`, requestBody)
}

function getManualBonusList() {
  return apiHelper(`/`, false).get(`${SHARED.BONUS_JSON_URL}`)
}

function getMemberAvailableBonusList() {
  const requestBody = {
    params: {
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper().get(`/${BONUS.BONUS}`, requestBody)
}

function getMinimumBonusDeposit() {
  return apiHelper().get(`/${BONUS.BONUS}${BONUS.MINIMUMDEPOSIT}`)
}

function getCategory() {
  return apiHelper().get(`/${BONUS.BONUS}/${BONUS.CATEGORY}`)
}

function applyBonus(applyBonusObj) {
  const requestOptions = {
    bonus_id: applyBonusObj.bonusId,
    fund_in_amount: applyBonusObj.depositAmount,
    fund_in_trx_id: applyBonusObj.depositTransactionId
  }
  return apiHelper().post(`${BONUS.BONUS}`, requestOptions)
}

function applyVoucherBonus(voucherCodeObj) {
  const requestOptions = {
    code: voucherCodeObj.code
  }
  return apiHelper().post(`${BONUS.VOUCHER}/${BONUS.APPLY}`, requestOptions)
}

function checkVoucherBonus(voucherCodeObj) {
  const requestOptions = {
    code: voucherCodeObj.code
  }
  return apiHelper().post(`${BONUS.VOUCHER}/${BONUS.CHECK}`, requestOptions)
}

function getOverallBonusStatus() {
  return apiHelper().get(`${BONUS.BONUS}/${BONUS.OVERALLSTATUS}`)
}

function getBonusStatus() {
  return apiHelper().get(`${BONUS.BONUS}/${BONUS.STATUS}`)
}

function claimBonus(id) {
  return apiHelper().post(`${BONUS.BONUS}/${id}/${BONUS.CLAIM}`)
}

function checkVipBonus() {
  return apiHelper().get(`${BONUS.MEMBER}/${BONUS.VIPBONUS}`)
}

function applyVipBonus() {
  return apiHelper().post(`${BONUS.MEMBER}/${BONUS.VIPBONUS}`)
}

function claimProgressReward() {
  return apiHelper().post(`${BONUS.MEMBER}/${BONUS.VIPPROGRESS}`)
}

function claimIPLProgressReward() {
  return apiHelper().post(`${BONUS.MEMBER}/${BONUS.IPLVIPPROGRESS}`)
}

function getIPLEventStatus() {
  return apiHelper().get(`${BONUS.IPLEVENTDATE}`)
}

function getVipSummary() {
  const requestBody = {
    params: {
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper().get(`${BONUS.MEMBER}/${BONUS.VIP_REWARDS_SUMMARY}`, requestBody)
}

function getIPLVipSummary() {
  const requestBody = {
    params: {
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper().get(`${BONUS.MEMBER}/${BONUS.IPL_VIP_REWARDS_SUMMARY}`, requestBody)
}

function getRebateHistory(data) {
  // claim_window=1 signals the Bhaggo "yesterday only" listing for the rebate
  // claim widget. Other callers (transaction history, left-pane totals) omit
  // it and continue to receive the full rebate dataset.
  const requestBody = {
    params: {
      page: data.page,
      start_time: data.startTime,
      end_time: data.endTime,
      size: data.size,
      claim_window: data.claimWindow ? 1 : undefined
    }
  }
  return apiHelper().get(`${BONUS.BONUS}/${BONUS.REBATE_HISTORY}`, requestBody)
}

function claimRebate(data) {
  // For Bhaggo, FE always sends the 24h claim window so the API restricts the
  // claim to yesterday's BD-day rebate. Other brands receive null fields and
  // keep their previous "claim all" behavior on the API side.
  const requestBody = {
    start_time: (data && data.startTime) || null,
    end_time: (data && data.endTime) || null
  }
  return apiHelper().post(`${BONUS.BONUS}/${BONUS.REBATE_HISTORY}`, requestBody)
}
function getRebateSummaryHistory(rebateObj) {
  const requestBody = {
    params: {
      page: rebateObj.page,
      start_time: rebateObj.startTime,
      end_time: rebateObj.endTime,
      size: rebateObj.size
    }
  }
  return apiHelper().get(`${BONUS.BONUS}/${BONUS.REBATE_SUMMARY_HISTORY}`, requestBody)
}

function getRebateSummaryDetail(rebateObj) {
  const requestBody = {
    params: {
      claimed_date: rebateObj.claimed_date
    }
  }
  return apiHelper().get(`${BONUS.BONUS}/${BONUS.REBATE_SUMMARY_DETAIL}`, requestBody)
}
